export default {
	pt: {
		profile_info: 'Informações de perfil',
		update_profile_info: 'Atualize seus dados pessoais e de contato.',
		save_changes: 'Salvar alterações',
		account_deletion: 'Para excluir sua conta, envie um e-mail para',
		name: 'Nome',
	}
}

